(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('r21-collection-grid')) {
    customElements.define('r21-collection-grid', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-density]');
          if (!button || !this.contains(button)) return;
          this.dataset.gridDensity = button.dataset.density;
          this.querySelectorAll('[data-density]').forEach((item) => {
            item.setAttribute('aria-pressed', String(item === button));
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["r21-capsule-lookbook"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('r21-capsule-lookbook')) {
    customElements.define('r21-capsule-lookbook', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.links = [...this.querySelectorAll('.r21-capsule__open')];
        this.dialog = this.querySelector('dialog');
        this.stage = this.querySelector('.r21-capsule__stage');
        this.count = this.querySelector('output');
        this.links.forEach((link, index) => link.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.opener = link;
          this.showImage(index);
          this.oldOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.dialog.showModal();
          this.querySelector('.r21-capsule__close').focus({preventScroll:true});
        }));
        this.querySelector('.r21-capsule__close').addEventListener('click', () => this.dialog.close());
        this.stage.addEventListener('click', () => this.dialog.close());
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.showImage(this.index + Number(button.dataset.step))));
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.showImage(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        this.dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.oldOverflow || '';
          this.opener?.focus({preventScroll:true});
        });
      }
      showImage(index) {
        this.index = (index + this.links.length) % this.links.length;
        const link = this.links[this.index];
        const image = link.querySelector('img').cloneNode();
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.loading = 'eager';
        image.src = link.querySelector('img').currentSrc || image.src;
        this.stage.replaceChildren(image);
        const large = new Image();
        large.src = link.href;
        large.decode().then(() => { if (image.isConnected) image.src = large.src; }).catch(() => {});
        this.count.textContent = String(this.index + 1).padStart(2,'0') + ' / ' + this.links.length;
      }
      disconnectedCallback() {
        if (this.dialog?.open) {
          this.dialog.close();
          document.documentElement.style.overflow = this.oldOverflow || '';
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
